import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';

import { BrowserRouter } from 'react-router-dom';
import {AppContainer} from './components/AppContainer';

ReactDOM.render(
    <BrowserRouter>
      <AppContainer />
    </BrowserRouter>
  ,
  document.getElementById('app')
);


// WEBPACK FOOTER //
// ./src/index.js